import { extend } from "@/themes/themeUtils";

import base from "./base";

// TODO: Clarify for Redesign
export default extend(base, {
  backgroundPrimary: "#444444",
  backgroundSecondary: "#7B7B7B",
  textPrimary: "#FFFFFF",
});
